export const publicInfo = state => state;
